<template>
    <div v-show="value" class="routerBgCover" style="display: block;">
        <Spin fix>
            <Icon type="ios-loading" size="33" class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</template>
<script>
    export default {
        name: "goLoading",
        props: {
            value: {
                default: false
            }
        },
        data() {
            return {};
        },
        computed: {},
        mounted() {
        },
        beforeDestroy() {
        },
        methods: {}
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/goLoading/goLoading.vue